<p-progressSpinner *ngIf="spinner"></p-progressSpinner>
<div class="panel_wrapper">
  <div class="d-flex flex-row justify-content-between pb-2">
    <div class="d-flex flex-row">
      <input (change)="onFileSelected($event)" class="open-file" style="display: none;" type="file" id="openFile"
        #openFile name="openFile" accept="image/png, image/jpg, image/jpeg" />
      <img class="edit_employee_profile_picture" (click)="openAddImage()"
        [src]="venueModel.pictureUrl? venueModel.pictureUrl : imagePath  " alt="profile-picture">
      <div class="picture-edit align-self-center">
        <p class="primary_medium_text_16 m-0">
          {{ 'VENUE.UPLOAD_IMAGE_MESSAGE' | translate }}
          <label *ngIf="pictureIsWrongFormat">
            <i class="pi pi-exclamation-circle me-1 error_color wrong_format_tooltip"
              pTooltip="{{'VENUE.WRONG_FORMAT' | translate}}" tooltipPosition="top"></i>
          </label>
        </p>
      </div>
    </div>
  </div>

  <div>
    <div class="w-100 mb-3">
      <label class="lbl_pos_field">{{'VENUE.VENUE_NAME' | translate}}
        <i *ngIf="errorModel!=null && errorModel['name']!=null"
          class="pi pi-exclamation-circle me-1 mt-1 error_color float-end" pTooltip="{{errorModel['name']|translate}}"
          tooltipPosition="top"></i>
      </label>
      <input type="text" class="primary_input_field mt-1" [(ngModel)]="venueModel.name">
    </div>
    <div class="w-100 mb-3">
      <label class="lbl_pos_field">{{'VENUE.PHONE_NUMBER' | translate}}
        <i *ngIf="errorModel!=null && errorModel['phone']!=null"
          class="pi pi-exclamation-circle me-1 mt-1 error_color float-end" pTooltip="{{errorModel['phone']|translate}}"
          tooltipPosition="top"></i>
      </label>
      <input type="number" class="primary_input_field custom_number_input mt-1" [(ngModel)]="venueModel.phone">
    </div>
    <div class="w-100 mb-3">
      <label class="lbl_pos_field">{{'VENUE.VENUE_ADDRESS' | translate}}
        <i *ngIf="errorModel!=null && errorModel['adress']!=null"
          class="pi pi-exclamation-circle me-1 mt-1 error_color float-end" pTooltip="{{errorModel['adress']|translate}}"
          tooltipPosition="top"></i>
      </label>
      <input #search type="text" class="primary_input_field mt-1" autocapitalize="off"
             spellcheck="false" [(ngModel)]="venueModel.address" placeholder="" (input)="onAddressManualChange()">    </div>
    <div class="w-100 mb-3">
      <label *ngIf="!enableEdit" class="lbl-table-capacity">{{'VENUE.TABLE_CAPACITY_MESSAGE' | translate}}</label>
    </div>
    <div class="w-100 ">
      <button *ngIf="!enableEdit" class=" btn-group-text btn-create-capacity-venue w-100 mt-0 mb-3" (click)="createCapacityForVenue()">{{ 'VENUE.CREATE_TABLE_CAPACITY'
        |translate}}</button>

      <button class=" btn-group-text create_btn w-100 " *ngIf="!enableEdit" (click)="addVenue(venueModel)">{{ 'SAVE'
        |translate}}</button>
      <button class=" btn-group-text create_btn w-100 " *ngIf="enableEdit" (click)="updateVenue(venueModel)">{{ 'SAVE'
        |translate}}</button>
    </div>
  </div>

</div>
